<template>
  <div>
      <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
              <text-input v-model="form.public_name" :error="form.errors.public_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Public name')" />
              <text-input v-model="form.short_description" :error="form.errors.short_description" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Short description')" />
              <text-input v-model="form.admin_side" :error="form.errors.admin_side" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Admin side')" />
              <text-input v-model="form.public_side" :error="form.errors.public_side" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Public side')" />
              <text-input v-model="form.admin_field" :error="form.errors.admin_field" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Admin field')" />
              <text-input v-model="form.public_field" :error="form.errors.public_field" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Public field')" />
              <textarea-input name="details" v-model="form.details" :error="form.errors.details" class="pr-6 pb-8 w-full" :label="__('Details')" />
              <file-input v-model="form.image" :error="form.errors.image" class="pb-8 pr-6 w-full lg:w-1/3" type="file" accept="image/*" :label="__('Image')" />

              <div class="w-full lg:w-1/3 flex items-center justify-start">
                  <img v-if="event_location.image" class="block mb-2 w-8 h-8 " alt="" :src="event_location.image" />
              </div>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
            {{ __('Delete') }} {{ __('Location') }}</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }} {{ __('Location') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
      FileInput,
      TextareaInput,
    TrashedMessage,
    Link,
      Head,
  },
  layout: Layout,
  props: {
    title: String,
      event_location: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          name: this.event_location.name,
          public_name: this.event_location.public_name,
          short_description: this.event_location.short_description,
          image: null,
          admin_side: this.event_location.admin_side,
          public_side: this.event_location.public_side,
          admin_field: this.event_location.admin_field,
          public_field: this.event_location.public_field,
          details: this.event_location.details,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('event_locations.update', this.event_location.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this event location?')) {
        this.$inertia.delete(this.route('event_locations.destroy', this.event_location.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this event location?')) {
        this.$inertia.put(this.route('event_locations.restore', this.event_location.id))
      }
    },
  },
}
</script>
